export default "__VITE_ASSET__BVVuJlLl__"